import React from "react";
import styled, { css } from "styled-components";

import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { FileData } from "src/core/shared/components/files/ListFiles";

interface FileItemProps {
  onFileClick: (file: FileData) => void;
  icon?: Icons;
  file: FileData;
}

/**
 * Renders a file item with an icon, and passes the event back when icon clicked
 */
const FileItem: React.ReactFCWithChildren<FileItemProps> = ({
  onFileClick,
  file,
  icon = Icons.CLOSE
}) => {
  return (
    <Item>
      <span className="file-name">
        {file.name}
      </span>

      <div
        onClick={event => {
          event.stopPropagation();
          onFileClick(file);
        }}
      >
        <Icon
          icon={icon}
          $fillColor="primaryDark"
          cursor="pointer"
        />
      </div>
    </Item>
  );
};

const Item = styled.li`
    ${({ theme }) => css`
    padding: ${theme.spacing.padding.sm};
    border-radius: 4px;
    box-sizing: border-box;
    background-color: ${theme.colors.lightGrey};
    max-width: 50%;
    margin-bottom: ${theme.spacing.margins.sm};
    display: flex;
    justify-content: space-between;
    align-items: center;

    .file-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 85%;
    }
  `}
`;

export default FileItem;
